import { Text, Flex } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import { MILLISECONDS_DAY_FACTOR } from 'global/appConstants';
import { routePaths } from 'global/routePaths';
import { useUserObject } from 'store/useUserStore';

const TrialBadge: React.FC<unknown> = () => {
  const { t } = useTranslation(['components', 'common', 'accountBilling']);

  const navigate = useNavigate();
  const userStore = useUserObject();

  const timeDuration = userStore?.companyInfo?.valid_until
    ? Math.floor((new Date(userStore?.companyInfo?.valid_until).getTime() - Date.now()) / MILLISECONDS_DAY_FACTOR)
    : null;

  if (timeDuration === null) return null;

  return (
    <Flex alignItems="center" justifyContent="center" p="3" bg="primary.50">
      <Text fontSize={{ base: 'md', lg: 'lg' }} mr="4" lineHeight="1.4">
        {timeDuration > 0
          ? t('components:yourTrialExpiresIn', { timeDuration: timeDuration })
          : timeDuration === 0
            ? t('components:yourTrialExpiresToday')
            : t('components:trialPeriodOver')}
        .{' '}
        <Text as="span" display={{ base: 'none', md: 'inline' }}>
          {t('components:clickAddCardToContinueService')}
        </Text>
      </Text>
      <Button colorScheme="secondary" onClick={() => navigate(routePaths.accountBilling.upgrade)}>
        {t('accountBilling:upgradeNow')}
      </Button>
    </Flex>
  );
};

export default TrialBadge;
